import _ from 'underscore';

import { Module } from '../Module';
import { IEmbeddedPasswordUpdate } from '../resources/DataConnections';
import { PasswordUnchanged } from '../services/EditConnectionAction';

interface IEmbeddedPasswordScope extends ng.IScope {
  password: {
    isEmbedded: boolean;
    newPassword: string;
  };

  passwordRequired: boolean;

  focusPasswordBox: () => void;
  inPasswordEditMode: () => boolean;
  editPassword: () => void;
}

Module.instance().directive('tbEmbeddedPassword', <any[]>[
  '$timeout',
  ($timeout: ng.ITimeoutService) => {
    return {
      restrict: 'E',
      replace: true,
      templateUrl: 'embeddedPassword.html',
      scope: {
      },
      require: 'ngModel',
      link: ($scope: IEmbeddedPasswordScope, element: JQuery, attrs: ng.IAttributes, ctrl: ng.INgModelController) => {

        $scope.passwordRequired = !_.isUndefined(attrs['tbEmbeddedPasswordRequired']);
        $scope.password = {
          isEmbedded: undefined,
          newPassword: ''
        };

        let inEditMode: boolean = undefined;

        ctrl.$render = () => {
          $scope.password.isEmbedded = (<IEmbeddedPasswordUpdate> ctrl.$modelValue).isEmbedded;

          // Determine initial password edit mode
          if (_.isUndefined(inEditMode)) {
            inEditMode = !$scope.password.isEmbedded;
          }

          if ($scope.passwordRequired) {
            $scope.password.isEmbedded = true;
          }
        };

        $scope.inPasswordEditMode = () => {
          return inEditMode;
        };

        $scope.editPassword = () => {
          inEditMode = true;
          updateModel();
        };

        $scope.focusPasswordBox = () => {
          $timeout(() => element.find('.tb-text-box-input').focus());
        };

        $scope.$watch('[password.isEmbedded, password.newPassword]', () => updateModel(), true);

        function updateModel() {
          ctrl.$setViewValue({
            isEmbedded: $scope.password.isEmbedded,
            newPassword: $scope.password.isEmbedded && inEditMode ? $scope.password.newPassword : PasswordUnchanged
          });
        }

      }
    };
  }
]);
